import ApiClient from './ApiClient';

class MultiChannelCampaignsAPI extends ApiClient {
  constructor() {
    super('multi_channel_campaigns', { accountScoped: true });
  }

  // Start a new run (planning) for a campaign.
  createRun(campaignId) {
    return axios.post(`${this.url}/${campaignId}/runs`);
  }

  getRuns(campaignId) {
    return axios.get(`${this.url}/${campaignId}/runs`);
  }

  getRun(campaignId, runId) {
    return axios.get(`${this.url}/${campaignId}/runs/${runId}`);
  }

  // Approve a planned run — this is what actually starts the sending.
  approveRun(campaignId, runId) {
    return axios.post(`${this.url}/${campaignId}/runs/${runId}/approve`);
  }

  cancelRun(campaignId, runId) {
    return axios.post(`${this.url}/${campaignId}/runs/${runId}/cancel`);
  }

  pause(campaignId) {
    return axios.post(`${this.url}/${campaignId}/pause`);
  }

  resume(campaignId) {
    return axios.post(`${this.url}/${campaignId}/resume`);
  }

  getRecipients(campaignId, runId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/runs/${runId}/recipients`, {
      params,
    });
  }
}

export default new MultiChannelCampaignsAPI();
